import React from "react";  
import CardContainer from "./CardContainer";
import Button from "./Button";
import LogoSection from "./LogoSection";

const AudienceResult = ({handleNavigateClick,styles}) => {

     const logos = [
    { src: '/images/logos/heavenMayhemLogo.webp', alt: 'Heaven Mayhem' },
    { src: '/images/logos/liquidIvLogo.webp', alt: 'Liquid IV logo', height: '40px' },
    { src: '/images/logos/neuroLogo.webp', alt: 'Marcha Logo' },
    { src: '/images/logos/trulyLogo.webp', alt: 'Truly Beauty Logo' },
    { src: '/images/logos/faytLogo.webp', alt: 'Fayt the label logo', height: '50px' },
    { src: '/images/logos/maskLogo.webp', alt: 'Mask Logo' },
    { src: '/images/logos/aclerLogo.webp', alt: 'Acler Logo' },
    { src: '/images/logos/july.webp', alt: 'July logo', height: '40px' },
  ];

  return (
   <section className={`${styles.container} ${styles.resultSection}`}>
          <div className={styles.headingContainer}>
            <h1 className={styles.sectionTitle}>Real results from real customers</h1>
            <p className={styles.sectionSubTitle}>See how fast-growing brands are winning with Instant Audiences</p>
          </div>
          <ul className={styles.cardContainer}>
            <li className='half-width'>
              <CardContainer className={styles.audienceResultCard} onClick={()=>handleNavigateClick('https://www.instant.one/case-studies/the-collagen-co')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>The Collagen Co</h2>
                  <p className={styles.cardDesc}>The Collagen Co increased revenue by <span className={styles.greenHighlight}>$150k</span> in 30 days with Instant Audiences</p>
                </div>
                
                <img src="/images/logos/collagenLogo.webp" alt="Collagen logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>

            <li className='half-width'>
              <CardContainer className={styles.audienceResultCard}  onClick={()=>handleNavigateClick('https://www.instant.one/case-studies/how-mercha-grew-retention-revenue-13-in-30-days-with-instant-ai-audiences')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>Mercha</h2>
                  <p className={styles.cardDesc}>How Mercha Grew Retention Revenue <span className={styles.greenHighlight}>13x</span> in 30 Days With Instant AI + Audiences</p>
                </div>
                <img src="/images/logos/merchaLogo.webp" alt="Collagen logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>

            <li className='half-width'>
              <CardContainer className={styles.audienceResultCard} onClick={()=>handleNavigateClick('https://www.instant.one/case-studies/how-instant-increased-golfbox-s-revenue-by-577k-per-month')}>
                <div className={styles.textContainer}>
                  <h2 className={styles.cardHeading}>GolfBox</h2>
                  <p className={styles.cardDesc}>How Instant Increased GolfBox’s Revenue By <span className={styles.greenHighlight}>$577k</span> Per Month</p>
                </div>
                <img src="/images/logos/golfBoxLogo.webp" alt="Collagen logo" className={styles.brandLogoImage} />
              </CardContainer>
            </li>
          </ul>
          <div className={styles.logoSectionContainer}>
            <LogoSection logos={logos}/>
          </div>

          <div className={styles.centerCtaContainer}>
            <Button onClick={()=>handleNavigateClick('https://www.instant.one/case-studies')}>View all success stories</Button>
          </div>

        </section>
  );
}   

export default AudienceResult;